import {
  revisename,
  updataqiye,
  getuserinfo,
  revisePhone,
  getZCvritfy
} from '../../../../../../apis/apis'
export default{
  name:'business',
  data(){
    return{  
      oldphone:'',
      newphone:'',
      verify:'',
      getZCmessage:'获取验证码',
      checkBox:false,
      masklayer:false,
      show:false,
      enterpriseId:JSON.parse(sessionStorage.getItem('user-login')).enterpriseId,
      dialogImageUrl: '',
      dialogVisible: false,
      userNews:JSON.parse(sessionStorage.getItem('user-login')),
      password: ['******'],
      i: 0,
      businessName:'',
      createTime:'',
      AdministratorName:'挂利用',
      AdministratorPhone:'18755777429',
      ID:'',
      loginName:'',
      type:'',
      auditTime:'',
      commitment:'',
      businessLicense:'',
      loge:'',
      sign:1,
      attime:'',
      fileList: [{url: ''}],
    }
  },
  mounted(){
    this.attime = this.userNews.auditTime
    this.loge = this.userNews.logo
    this.businessLicense = this.userNews.businessLicense
    this.commitment = this.userNews.commitment
    this.auditTime = this.userNews.auditTime
    this.AdministratorName = this.userNews.name,
    this.AdministratorPhone = this.userNews.phone,
    this.businessName = this.userNews.enterprise
    this.createTime = this.userNews.createTime
    this.ID = this.userNews.id,
    this.loginName = this.userNews.loginName
    if(this.userNews.userType === 1 || this.userNews.userType === 4) {
      this.type = '企业账户'
    }
  },
  methods:{
    handleRemove(file, fileList) {
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    success(repone){
      this.sign === 1 ? this.loge = repone.data : this.sign ===2 ? this.businessLicense = repone.data :this.commitment = repone.data
      this.updata()
    },
    logo(v){
      this.sign = v
      this.sign === 1 ? this.fileList[0].url = this.userNews.logo : this.sign === 2 ? this.fileList[0].url = this.userNews.businessLicense : this.fileList[0].url = this.userNews.commitment
      this.masklayer = true
      this.show = true
    },
    Delete(){
      this.masklayer = false
      this.show = false
      this.checkBox = false
    },
    getinfo(){
      this.$ajaxGet(getuserinfo,{
        token:sessionStorage.getItem('token'),
        userId:this.userNews.id,
        enterpriseId:this.userNews.enterpriseId
      }).then(res=>{
        if(res.data.code != 0){
          this.$message({
            title:'错误',
            type:'error',
            message:res.data.msg
          })
        }else{
          JSON.parse( sessionStorage.setItem('user-login',JSON.stringify(res.data.data)))
        }
      })
    },
    // 后去验证码
    Verify() {
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.newphone)) {
        this.$message({
          title: "错误",
          type: "error",
          message: "请正确填写手机号码",
        });
      } else {
        //点击后60s之后才能获取信息
        clearInterval(this.setIntervalMessage);
        this.clickMessage = 60;
        this.getZCmessage = `请在${this.clickMessage}s后重试`;
        this.setIntervalMessage = setInterval(() => {
          this.clickMessage--;
          this.getZCmessage = `请在${this.clickMessage}s后重试`;
          if (this.clickMessage == 0) {
            clearInterval(this.setIntervalMessage);
            this.getZCmessage = `获取验证码`;
          }
        }, 1000);
        this.$ajaxGet(getZCvritfy,{
          phone:this.newphone
        }).then(res=>{
          console.log(res);
          if (res.data.code != 0) {
            this.$message({
              title:'错误',
              type:'error',
              message:res.data.msg
            })
            clearInterval(this.setIntervalMessage);
            this.getZCmessage = `获取验证码`;
          }
          else {
            this.$message({
              title:'正确',
              type:'success',
              message:res.data.msg
            })
          }
        })
          .catch((err) => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: "确定",
              type: "error",
            });
          });
      }  
    },
    // 修改手机号
    submit() {
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.oldphone)) {
        this.$message({
          title: "错误",
          type: "error",
          message: "请正确填写手机号码",
        });
      }else{
        this.$ajaxGet(revisePhone,{
          phone:this.oldphone,
          newPhone:this.newphone,
          verifyCode:this.verify
        }).then(res=>{
          if (res.data.code != 0) {
            this.$message({
              title:'错误',
              type:'error',
              message:res.data.msg
            })
          }else{
            this.$message({
              title:'成功',
              type:'success',
              message:'修改成功，请重新登录'
            })
            // 退出登录
            sessionStorage.removeItem('user-login')
            sessionStorage.removeItem('token')
            this.$router.push({
              name: 'home'
            })
          }
        })
          .catch((err) => {
            this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
              confirmButtonText: "确定",
              type: "error",
            });
          });
      }
    },
    updata(){
      this.$ajaxPost(updataqiye,{
        enterprise:{
          businessLicense: this.businessLicense,
          commitment: this.commitment,
          enterpriseName: this.businessName,
          logo: this.loge,
          id:this.enterpriseId,
          account:this.loginName,
          mainPerson: this.AdministratorName,
          mainPersonMobile: this.AdministratorPhone,
        },
        userId:this.userNews.id
      }).then(res=>{
        if(res.data.code != 0){
          this.$message({
            title:'错误',
            type:'error',
            message:res.data.code
          })
        }else{
          console.log(res);
          this.$message({
            title:'成功',
            type:'success',
            message:'修改成功'
          })
          this.getinfo()
        }
      })
    },
    eyeshow() {
      this.$router.push({name:'homeChange'})
    },
    // 修改名字接口
    reverName(value1) {
      this.$ajaxPost(revisename,{
        name:this.AdministratorName,
        newName:value1
      }).then(res=>{
        if(res.data.code != 0) {
          this.$message({
            title:'错误',
            type:'error',
            message:res.data.msg
          })
        }else{
          this.$message({
            title:'成功',
            type:'success',
            message:res.data.data
          })
        }
      })
    },
    xiuname(v) {
      if(v === 1) {
        this.$prompt('请修改企业名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.businessName = value
          this.updata()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      }
      else if(v === 6){
        this.$prompt('请修改登录账号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.businessName = value
          this.updata()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      }
      else if(v === 7){
        this.$prompt('请修改账号id', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.ID = value
          this.updata()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      }else{
        this.$prompt('请修改名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          this.reverName(value)
          this.AdministratorName = value
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      }
    },
    xiuphone() {
      this.masklayer = true
      this.checkBox = true
    },
  }
}